module.exports = __webpack_public_path__ + "img/droplet-fill.de7dbf41.svg";